
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { listItem } from 'components/banners/DisplayItems';
import AuthButton from 'components/base/AuthButton';
import ContentSections from 'components/base/ContentSections';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import Loading from 'components/base/Loading';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { APIStatus, LanguageConfig } from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';

import { createAction } from 'utils';
import i18n from '../../../I18n';

const mapPropsToState = (state) => ({
  status: state.loading.status,
  productCategory: state.createProductCategory.productCategory,
  languages: state.language.allList,
})

const ProductCategoryDetail = ({
  productCategory,
  status,
  languages,
}) => {
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (params.id) {
      dispatch(createAction('language/getList')({ isSelectorLoad: true }));
      dispatch(
        createAction('createProductCategory/getOneProductCategory')({ id: params.id })
      );
    }
  }, [dispatch, params.id]);

  const topRightButtons = [
    <AuthButton
      title="Edit"
      action={() => history.push('edit/')}
      requires={PermissionCodes.changeProductCategory}
    />
  ];


  const renderTabForLanguage = (language) => {
    const translatedName = productCategory?.translations?.[language]?.name || productCategory.name
    const displayOrder = productCategory?.displayOrder || "-"
    return [
      <>
        <div className="first-section-title">
          {i18n.t('information', { locale: language })}
        </div>
        {listItem('Name(Order)', translatedName)}
        {listItem('Display order', displayOrder)}
        <CustomTitleLabel title={'Assigned product subcategory (Order)'} />
        {
          productCategory?.productSubcategories?.length > 0
            ? productCategory?.productSubcategories?.map((data) => <li>{data?.name}</li>)
            : "-"
        }
        <CustomTitleLabel title={`Linked physical store's product category`} />
        {
          productCategory?.linkedPhysicalStoreProductCategories?.length > 0
            ? productCategory?.linkedPhysicalStoreProductCategories?.map((data) => <li>{data?.name}</li>)
            : "-"
        }
        <CustomTitleLabel title={`Linked physical store's product subcategory`} />
        {
          productCategory?.linkedPhysicalStoreProductSubcategories?.length > 0
            ? productCategory?.linkedPhysicalStoreProductSubcategories?.map((data) => <li>{data?.name}</li>)
            : "-"
        }
        <CustomTitleLabel title={`Linked online store's product category`} />
        {
          productCategory?.linkedOnlineStoreCollections?.length > 0
            ? productCategory?.linkedOnlineStoreCollections?.map((data) => <li>{data?.label || '-'}</li>)
            : "-"
        }
        <CustomTitleLabel title={`Linked online store's product subcategory`} />
        {
          productCategory?.linkedOnlineStoreTags?.length > 0
            ? productCategory?.linkedOnlineStoreTags?.map((data) => <li>{data?.label}</li>)
            : "-"
        }
      </>,
      <>
        <div className="first-section-title">
          {i18n.t('general', { locale: language })}
        </div>
        {listItem('Creation time', productCategory.detailDisplayCreationDate || "-")}
        {listItem('Last modified time', productCategory.detailDisplayLastModifiedDate || "-")}
        {listItem('Last modified by', productCategory.displayLastModifiedBy || "-")}
      </>
    ]
  }
  const tabs = [
    {
      name: 'Detail',
      content:
        status === APIStatus.calling ? (
          <Loading />
        ) : (
          <div className="scroll-container-common">
            <ContentSections
              hidePreview
              languageTabContent={{
                containers: languages?.map((item) => ({
                  container: renderTabForLanguage(item.code),
                  key: item.code,
                  title: item.sourceName,
                })),
              }}
              activeSection={LanguageConfig.english}
            />
          </div>
        ),
    },
  ]

  return (
    <>
      <CustomListComponent
        caution={{
          detail: '',
          title: productCategory?.name || "",
        }}
        breadcrumb={
          <CustomBreadcrumb name={productCategory?.name || ""} />
        }
        hideTab={false}
        tabs={tabs}
        buttons={topRightButtons}
      />
    </>
  );
}
export default connect(mapPropsToState)(ProductCategoryDetail);